import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { globalSearch } from "./api";

/** Debounce a fast-changing value (the search box) so we query on a pause. */
export function useDebounced<T>(value: T, delay = 250): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}

export function useGlobalSearch(query: string) {
  const q = query.trim();
  return useQuery({
    queryKey: ["search", q],
    queryFn: () => globalSearch(q),
    enabled: q.length >= 2,
    staleTime: 30_000,
  });
}
